import React from "react";
import {useIntl} from "react-intl";
import SquadflixRowTitle from "../squadflixRowTitle/squadflixRowTitle";
import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemBackdropDetails from "../../shared/item-backdrop-details/item-backdrop-details";
import {StremioMeta} from "../../../../apis/towers-sports-api/types";
import {Spinner} from "../../../shared";
import {Link, useNavigate} from "react-router-dom";
import {useStremioChannelsData} from "../../hooks/useCatalogRowData";

type Props = SquadflixRowsBaseProps & {
    onChannelClick?: (item: StremioMeta) => void;
    onDetailsClick?: (item: StremioMeta) => void;
    customTitle?: React.ReactNode;
    activateShadow?: boolean;
    hideIds?: string[];
}

export const StremioChannelsRow = (props: Props) => {
    const {onChannelClick, onDetailsClick, order, activateShadow = true} = props;
    const {channels, loading} = useStremioChannelsData();
    const intl = useIntl();
    const navigate = useNavigate();

    const navigateToChannel = (channel: StremioMeta) => {
        if (channel.id) {
            navigate(`/squadflix/live/channel/${channel.id}`);
        }
    }

    if (loading) {
        return <div style={{height: "393px", overflow: "hidden", order: props.order ?? 0}}
                    className="d-flex justify-content-center align-items-center">
            <Spinner/>
        </div>
    }
    if (!channels?.length) {
        return <div style={{height: "393px", overflow: "hidden", order: props.order ?? 0}}
                    className="d-flex justify-content-center align-items-center">
            <span>Vaya! No hay links, es posible que algo esté fallando.</span>
        </div>
    }

    return (
        <div style={{height: "fit-content", overflow: "hidden", order: order ?? 0}}>
            <SquadflixRowTitle
                extraOptions={<Link to="/squadflix/live/custom" className="btn btn-sm btn-outline-secondary me-2">Tus
                    LINKS <i className="fa-solid fa-link"></i></Link>}
                icon={<i className="fa-solid fa-tower-broadcast"></i>}
                title={intl.formatMessage({id: "squadflix.live"})} {...props}/>
            <ItemsHorizontalScroll activateShadow={activateShadow}>
                <div className="d-flex flex-row gap-3" style={{paddingLeft: "13px", paddingRight: "13px"}}>
                    {channels.map((item) => {
                        if (props.hideIds?.includes(item.id)) {
                            return null;
                        }
                        return (<div key={item.id}>
                            <ItemBackdropDetails
                                onClickPoster={() => onChannelClick ? onChannelClick(item) : navigateToChannel(item)}
                                onClickDetails={() => onDetailsClick ? onDetailsClick(item) : navigateToChannel(item)}
                                aspectRatio={"9 / 12"}
                                style={{
                                    width: "min(142px, 25vw)",
                                    position: "relative",
                                }}
                                cachedSrc={item.poster}
                                detailsTitle={item.name}
                                detailsSubtitle={item.streams ? `${item.streams} enlaces` : "Sin enlaces "}
                            />
                        </div>)
                    })}
                </div>
            </ItemsHorizontalScroll>
        </div>
    );
}
